import { useState, useEffect, useRef } from 'react';
import { getUserLocationUnitStr } from '../../util/location';
import { FILL_ADDRESS_STEP } from './helpers';

/**
 * Get location string from Form fields
 * @param {*} param0
 */

export const useLocationUnitsString = ({
    intl,
    setLocationUnits,
    values,
    form,
    valid,
    currentStep,
    excludeStreetNumber,
}) => {
    const { city, houseNumber, streetAddress, postalCode, country } = values;
    const [activeField, setActiveField] = useState(() => form.getState().active);
    const blurTimerRef = useRef(null);

    useEffect(() => {
        const unsubscribe = form.subscribe(({ active }) => setActiveField(active), {
            active: true,
        });

        return unsubscribe;
    }, [form]);

    const isCurrentlyFocused = Boolean(activeField);
    const [isAnyFieldActive, setIsAnyFieldActive] = useState(isCurrentlyFocused);

    useEffect(() => {
        if (isCurrentlyFocused) {
            if (blurTimerRef.current) {
                clearTimeout(blurTimerRef.current);
                blurTimerRef.current = null;
            }
            setIsAnyFieldActive(true);
        } else {
            blurTimerRef.current = setTimeout(() => {
                setIsAnyFieldActive(false);
                blurTimerRef.current = null;
            }, 1000);
        }

        return () => {
            if (blurTimerRef.current) {
                clearTimeout(blurTimerRef.current);
                blurTimerRef.current = null;
            }
        };
    }, [isCurrentlyFocused]);

    const predictAllowed = !isAnyFieldActive;
    const allFieldsAreFilled = Boolean(city && houseNumber && streetAddress && postalCode);

    const resolvePredictionAllowed =
        allFieldsAreFilled && currentStep === FILL_ADDRESS_STEP && predictAllowed && valid;

    useEffect(() => {
        if (resolvePredictionAllowed) {
            setLocationUnits(
                getUserLocationUnitStr({
                    intl,
                    country,
                    postalCode,
                    city,
                    streetAddress,
                    houseNumber: excludeStreetNumber ? '' : houseNumber,
                })
            );
        }
    }, [
        excludeStreetNumber,
        resolvePredictionAllowed,
        country,
        postalCode,
        city,
        streetAddress,
        houseNumber,
    ]);

    return { predictAllowed };
};
